import { ComponentProps } from 'react'
import { webchatClasses } from '../../../styles/classes'
import { VideoBlock, type CommonBlockProps } from '../../../types'

type Props = VideoBlock & CommonBlockProps & ComponentProps<'video'>

export const Video = ({ ref, url, isReadOnly, ...props }: Props) => {
  const {
    message: {
      blocks: { video },
    },
  } = webchatClasses

  return (
    <div>
      <video
        {...props}
        data-chromatic="ignore"
        style={isReadOnly ? { pointerEvents: 'none' } : undefined}
        controls
        src={url}
        {...video}
        ref={ref}
      />
    </div>
  )
}

Video.displayName = 'Video'
